module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 44
// module chunks = 0